/*
* General custom scripts
**/
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import { navMobile } from './components/nav-mobile';

navMobile();